import {logEvent as fbLogEvent, setUserProperties as fbSetUserProperties} from 'firebase/analytics';
import firebaseService from 'utils/firebase/firebase';

// Firebase modular SDK v9+ uses top-level functions; mobile RNFirebase used
// instance methods (firebase.analytics().setCurrentScreen). Web mirrors mobile
// surface via this wrapper.

export const logScreenView = async (screen) => {
  try {
    fbLogEvent(firebaseService.analytics(), 'screen_view', {firebase_screen: screen});
  } catch (e) {
    console.warn('[WEBGL_DBG] logScreenView failed', e);
  }
};

export const logEvent = async (name, params = {}) => {
  try {
    fbLogEvent(firebaseService.analytics(), name, params);
  } catch (e) {
    console.warn('[WEBGL_DBG] logEvent failed', e);
  }
};

export const setUserProperties = async (properties) => {
  try {
    fbSetUserProperties(firebaseService.analytics(), properties);
  } catch (e) {
    console.warn('[WEBGL_DBG] setUserProperties failed', e);
  }
};
